import NoAccessPage from '@/pages/NoAccessPage.vue'
import type { RouteRecordRaw } from 'vue-router'

import useHasPermissionUser from '@/composables/useHasPermissionUser'

import IndexPage from '@/modules/cards/pages/IndexPage.vue'

export default {
	path: '/cards',
	children: [
		{
			path: '',
			name: 'card.index',
			component: IndexPage,
			beforeEnter: (to, from, next) => {
				const { hasPermissionUser } = useHasPermissionUser()

				if (hasPermissionUser('viewAny', 'App\\Models\\Card')) {
					return next()
				}
				// Sin permiso: mostramos empty state honesto en lugar de 404 silencioso.
				return next({ name: 'card.noAccess' })
			},
		},
		{
			path: 'no-access',
			name: 'card.noAccess',
			component: NoAccessPage,
			props: {
				title: 'Tarjetas Enlace no disponibles para tu rol',
				description:
					'Tu usuario no tiene acceso al módulo de tarjetas. Si crees que deberías verlo, contacta al administrador de tu empresa.',
				icon: 'credit_card_off',
			},
		},
	],
} as RouteRecordRaw
